module.exports = __webpack_public_path__ + "media/video.38bb8044.mp4";